import Vue from "vue";
import { appConfig } from "./utils.js";
const api = appConfig.api_path;

export function searchProducts(qryConds) {
  return Vue.http.get(api + 'product/list', { params: qryConds })
}

export function saveProduct(product) {
  return Vue.http.post(api + 'product/save', product)
}

export function getProducts(codes) {
  return Vue.http.post(api + 'product/bycodes', { codes: codes })
}
